(function () {
    'use strict';

    run.admin.parts.rackootCreateSimple = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        // const create_rackoot_container = document.getElementById('rackoots_items__create');
        const create_rackoot_button = document.getElementById('rackoots_items__create');
        if (create_rackoot_button != null) {
            // const create_rackoot_button = create_rackoot_container.querySelector('button');
            create_rackoot_button.addEventListener('click', async function(e) {
                // const countItems = document.getElementById('rackoots_dropdown_list').querySelectorAll('li').length;
                //const countItems = document.querySelectorAll('.swiper-slide.rackoot__item').length;
                const maxRackoots = create_rackoot_button.dataset.maxRackoots;
                const countItems = create_rackoot_button.dataset.countRackoots;
                if (countItems >= maxRackoots) {
                    Swal.fire({
                        title: translations.rackoots.create.title,
                        html: translations.rackoots.create.errors.maxReached,
                        showCloseButton: false,
                        showCancelButton: true,
                        showConfirmButton: false,
                        focusCancel: true,
                        cancelButtonText: translations.confirmAlerts.close,
                        confirmButtonText: translations.confirmAlerts.createRackoot,
                        buttonsStyling: false,
                        //reverseButtons: true,
                        customClass: {
                            cancelButton: 'btn btn-lg btn-light',
                            confirmButton: 'btn btn-lg btn-primary ms-4'
                        },
                        showClass: {
                            popup: 'animate__animated animated__fast animate__fadeInUp'
                        },
                        hideClass: {
                            popup: 'animate__animated animated__fast animate__fadeOutDown'
                        }
                    }).then((result) => {
                        if (result.value) {}
                    });
                } else {
                    const { value: rackoot_name } = await Swal.fire({
                        title: translations.rackoots.create.title,
                        input: 'text',
                        inputLabel: 'Name',
                        inputValue: null,
                        showCancelButton: true,
                        inputAttributes: {
                            maxlength: 100,
                            autocapitalize: 'off',
                            autocorrect: 'off'
                        },
                        inputValidator: (value) => {
                            if (!value) {
                                return translations.rackoots.create.errors.name;
                            }
                        }
                    })
                      
                    if (rackoot_name) {
                        var data = new FormData();
                        data.append('csrf_name', csrf_name);
                        data.append('csrf_value', csrf_value);
                        data.append('name', rackoot_name);
        
                        axios.post(GlobalRoutes.rackoots.create, data)
                        .then(function (response) {
                            window.location = response.data.data.url;
                        })
                        .catch(function (error) {
                            new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                        });
                    }
                }
            });
        }
    }
})();